import React, { useRef, useContext, useEffect } from "react"
import  { Link, navigate } from "gatsby"

import { MDXRenderer } from "gatsby-plugin-mdx"

import PropTypes from "prop-types"
import styled from "styled-components"

import Divider from '@mui/material/Divider';

import ContentWrapper from "../../styles/contentWrapper"

import logo from "content/images/logo.svg"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXTwitter, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  padding: 4rem 0;
  background: #292b33;
  color: white;

`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    padding-right: 1rem;
    padding-left: 1rem;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }
    .section-title {
      font-style: normal;
      font-weight: 700;
      font-size: 2.4rem;
      line-height: 3rem;
      letter-spacing: -1.5px;
      color: #386097;
      margin: auto;
      span {
        color: #282A32;
      }
      text-align: center;
      margin-top: 0;
      margin-bottom: 1rem;
      padding: 0 1rem;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .section-subtitle {
      color: #4E5D6B;
      font-size: 1rem;
      line-height: 1.5rem;
      text-align: center;
      margin-top: 0;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .inner-wrapper {
      p {
        margin: 3rem 0;
        text-align: center;
        font-size: 13px;
        opacity: 0.9;
      }
  
    }
  }
`

const StyledLogo = styled.img`
  position: relative;
  z-index: 10;

  height: 2rem;

  /* Disable effects when sidebar is open */
  filter: none !important;
  pointer-events: auto !important;
  user-select: auto !important;
`
const StyledDivider  = styled(Divider)`
  &.MuiDivider-root {
    margin: 4rem 0;
    border-color: rgba(255, 255, 255, 1);
    opacity: 1;
  }
`

const SyledDiv  = styled.div`
  display: flex; 
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  span {
    width: 100%;
    flex-basis: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    span {
      margin-top: 0;
      flex-basis: 33%;
      width: 33%;
    }
    span:first-of-type {
      justify-content: flex-start;
    }
    span:last-of-type {
      justify-content: flex-end;
    }
  }
  .socials {
    display: flex;
    a {
      width: 2rem;
      height: 2rem;
      margin: 0.5rem;
      background: white;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`

const Footer = ({ content }) => {
  const { frontmatter, body, exports } = content[0].node

  return (
    <StyledSection id="footer">
      <StyledContentWrapper>
        <StyledLogo src={logo} />
        <div
          className="inner-wrapper"
        >
          <MDXRenderer>{body}</MDXRenderer>
          <StyledDivider></StyledDivider>
          <SyledDiv>
            <span>© 2024 ManpowerGroup - all rights reserved.</span>
            <span className="socials">
             {/*  <a href="https://www.facebook.com/ManpowerBelgium/" target="blank">
                  <FontAwesomeIcon color="#292b33" icon={faFacebookF} />
              </a> */}
              <a href="https://www.linkedin.com/company/manpower-belgium/" target="blank">
                  <FontAwesomeIcon  color="#292b33" icon={faLinkedinIn} />
              </a>
              {/* <a href="https://x.com/ManpowerGroupBE" target="blank">
                  <FontAwesomeIcon color="#292b33" icon={faXTwitter} />
              </a> */}
           </span>
            <span><a href="http://hrflow.ai">Powered by HrFlow.ai</a></span>
          </SyledDiv>
        </div>
     
      </StyledContentWrapper>
    </StyledSection>
  )
}

Footer.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        body: PropTypes.string.isRequired,
        frontmatter: PropTypes.object.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
}

export default Footer
